<template>
  <input
    :class="dynamicClass"
    :type="type"
    :value="value"
    :placeholder="placeholder"
    :readonly="readonly"
    v-mask="mask"
    @input="emitInput"
    @blur="onBlur"
    v-if="mask"
  />
  <input
    :class="dynamicClass"
    :type="type"
    :value="value"
    :placeholder="placeholder"
    :readonly="readonly"
    @keypress.enter="onEnterPressed"
    @input="emitInput"
    @blur="onBlur"
    @focus="onFocus"
    v-else
  />
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: "text",
    },
    readonly: {
      type: Boolean,
      default: true,
    },
    value: {
      type: [String, Number],
    },
    placeholder: {
      type: String,
    },
    dark: {
      type: Boolean,
      default: false,
    },
    mask: {
      type: String,
      default: null,
    },
    valid: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    emitInput(e) {
      this.$emit("input", e.target.value);
    },
    onEnterPressed() {
      this.$emit("enterPressed");
    },
    onBlur() {
      this.$emit("blur");
    },
    onFocus() {
      this.$emit("focus");
    },
  },
  computed: {
    dynamicClass() {
      return {
        "black-input": true,
        "black-input-edit": !this.readonly,
        'black-input-dark': this.dark,
        "black-input-invalid": !this.valid,
      };
    },
  },
};
</script>

<style scoped>
.black-input {
  background: transparent;
  font-size: 2vh;
  display: block;
  width: 100%;
  padding: 0.3vh 1vh;
  text-align: center;

  border: 0.111vh solid #ededed;
  border-radius: 0.444vh;
  color: white;
  box-sizing: border-box;
}

.black-input-edit {
  background: #ffffff !important;
  color: black;
  outline: none;
  border: 0.111vh solid #ededed;
  border-radius: 0.444vh;
}

.black-input-invalid {
  border: 1px solid #e2223b;
  box-shadow: inset 0px 0px 0px 1px #e2223b;
}

.black-input-dark {
  background: #ededed !important;
  color: black;
  border: 0.111vh solid #908f8d;
}
</style>
